// extracted by mini-css-extract-plugin
export var productImage = "_wo-0";